import * as React from 'react';
import styles from './Navbar.module.scss';
import { NavLink } from 'react-router-dom';
import { TipsterRoutes } from './Routes';
import classNames from 'classnames';
//assets
import defaultTipsterImage from '../../assets/icons/ic_tipster_default.svg';

//tr
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ownedBetsActions } from '../../store/ownedBets/actions';
import { UnlockedTipData } from '../../store/tips/reducer';
import { useFeatureFlagContext } from '../__providers__/FeatureFlagsContext';

export interface StateProps {
  userImg: string;
  openData: { tips: UnlockedTipData[]; matches: any };
  closedData: { tips: UnlockedTipData[]; matches: any };
  requestLogout: () => void;
  user: any;
  setIsOpen: (bol: boolean) => void;
  isOpen: boolean;
}

export interface DispatchProps {
  getBets: (openstatus: any) => any;
}

type TipsterSidebarProps = StateProps & DispatchProps;

export const TipsterSidebar: React.FC<TipsterSidebarProps> = ({
  userImg,
  requestLogout,
  user,
  getBets,
  openData,
  closedData,
  setIsOpen,
  isOpen,
}) => {
  const cx = classNames.bind(styles);
  const { t } = useTranslation();
  const [selectedNav, setSelectedNav] = React.useState<string>('');
  const { isEnabled } = useFeatureFlagContext();

  React.useEffect(() => {
    getBets('open');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closedData]);

  //TODO: delete after permanent flag enable
  const isChannelsFlagEnabled = isEnabled('channel_based_tips_publishing');

  return (
    <div className={styles.sidebar}>
      <div className={styles.fixed}>
        <div>
          <div className={styles.tipsterName}>
            <img
              src={userImg || defaultTipsterImage}
              className={styles.avatar}
              alt="user profile pic"
            />
            <div>
              <p>{user.username}</p>
            </div>
          </div>

          <div className={styles.separator} />
          <div className={styles.routes}>
            {TipsterRoutes.map((section) => (
              <div key={section.key} className={styles.routeSection}>
                <div className={styles.sectionHeader}>
                  <p>{tr(t, section.key).toUpperCase()}</p>
                </div>

                {section.routes.map((route) => {
                  if (!isChannelsFlagEnabled && route.key === 'publish') {
                    return (
                      <div
                        key={route.key}
                        onClick={() => {
                          setSelectedNav(route.key);
                          setIsOpen(true);
                        }}
                        className={cx(
                          styles.item,
                          window.location.pathname.includes('/betPublish')
                            ? styles.active
                            : styles.inactive,
                        )}
                      >
                        <p
                          className={
                            window.location.pathname.includes('/betPublish')
                              ? styles.active
                              : styles.inactive
                          }
                        >
                          {tr(t, 'publish')}
                        </p>
                      </div>
                    );
                  } else if (route.key === 'close') {
                    return (
                      route.active && (
                        <div
                          className={cx(
                            styles.item,
                            selectedNav === route.key
                              ? styles.active
                              : styles.inactive,
                          )}
                          key={route.key}
                        >
                          <NavLink
                            to={route.path}
                            activeClassName={styles.active}
                            className={cx(styles.nav, styles.closeTips)}
                            onClick={() => setSelectedNav(route.key)}
                          >
                            <p>{tr(t, route.key)}</p>
                            <span className={styles.openTips}>
                              {openData
                                ? openData.tips.length >= 40
                                  ? '+40'
                                  : openData.tips.length
                                : 0}
                            </span>
                          </NavLink>
                        </div>
                      )
                    );
                  } else {
                    return (
                      route.active && (
                        <div
                          className={cx(
                            styles.item,
                            selectedNav === route.key
                              ? styles.active
                              : styles.inactive,
                          )}
                          key={route.key}
                        >
                          <NavLink
                            to={route.path}
                            activeClassName={styles.active}
                            className={styles.nav}
                            onClick={() => setSelectedNav(route.key)}
                          >
                            <p>{tr(t, route.key)}</p>
                          </NavLink>
                        </div>
                      )
                    );
                  }
                })}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.logoutWrapper} onClick={requestLogout}>
          {tr(t, 'logout')}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  openData: state.ownedBets.data.open,
  closedData: state.ownedBets.data.closed,
  loading: state.ownedBets.isLoading,
  error: state.ownedBets.error,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getBets: (openstatus: any) =>
    dispatch(ownedBetsActions.ownedBetsRequestAction(openstatus)),
});

export const TipsterSidebarConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TipsterSidebar);
